// set up azure Var
import axios from "axios";
import { getCountryFromUrl } from "./helpers";

export const getStoriesAzureAPI = (forceCountry) => {
  let StoriesAzureAPI;
  let country = getCountryFromUrl(forceCountry);

  // Check url to select appropriate Azure connection
  if (country == "us") {
    StoriesAzureAPI = axios.create({
      baseURL: "https://usstoryfunctions.azurewebsites.net/api/",
      params: {
        code: `${process.env.REACT_APP_US_KEY}`,
      },
      headers: {
        "Content-type": "application/json",
      },
    });
    StoriesAzureAPI.interceptors.request.use((config) => {
      config.params = {
        code: `${process.env.REACT_APP_US_KEY}`,
        ...config.params,
      };
      return config;
    });
  } else if (country == "aus") {
    StoriesAzureAPI = axios.create({
      baseURL:
        "https://ausstoryfunctions-apim.azure-api.net/AusStoryFunctions/StoryData/",
      headers: {
        "Content-type": "application/json",
        "FC-Key": `${process.env.REACT_APP_AUS_KEY}`,
      },
    });
  } else if (country == "ie") {
    StoriesAzureAPI = axios.create({
      baseURL:
        "https://irlstoryfunctions-apim.azure-api.net/StoryFunctionsIRL/StoryData/",
      headers: {
        "Content-type": "application/json",
        "FC-Key": `${process.env.REACT_APP_IE_KEY}`,
      },
    });
  } else {
    StoriesAzureAPI = axios.create({
      baseURL: "https://flightclubapi.azure-api.net/uk/v2/StoryData/",
      headers: {
        "Content-type": "application/json",
        "FC-Key": `${process.env.REACT_APP_UK_KEY}`,
      },
    });
  }

  return { StoriesAzureAPI, country };
};
